import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { ViewPaymentDetailModel } from "src/app/model/ViewPaymentDetailModel";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewProfileDocumentComponent } from "src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import { Page } from "src/app/model/Page";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TdsRejectComponent } from "../../payment-settlement/view/reject-case/tds-reject-case.component";
import { AppealDetailModel } from "src/app/model/AppealDetailModel";
import { TdsApproveComponent } from "../../payment-settlement/view/approve-case/tds-approve-case.component";
import { AppealRejectComponent } from "../reject-case/appeal-reject-case.component";
import { AppealCallHearingComponent } from "../hearing-case/appeal-call-hearing.component";
import { DatePipe } from "@angular/common";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { InstallmentAppealModel } from "src/app/model/InstallmentAppealModel";
import { InstallmentExtendModel } from "src/app/model/InstallmentTypeModel";
import moment from "moment";
import { AppealApproveDocComponent } from "../approve-doc-case/appeal-approve-doc-case.component";

@Component({
  selector: "app-secure-view-appeal-hearing-dtl",
  templateUrl: "./appeal-hearing-dtl.component.html",
  styleUrls: ["./appeal-hearing-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewAppealHearingDtlComponent implements OnInit {
  data: AppealDetailModel;
  // page: Page<AppealDetailModel>;
  dataSource: MatTableDataSource<InstallmentExtendModel> =
    new MatTableDataSource();
  applicationNo: number;
  appealType: string;
  appealDate: string;
  remark: string;
  extendDaysValue: string;
  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
  documents: any[] = [];
  verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  newInstmantDate: string;
  progressSpinnerDialog: any = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isSearchDisabled: boolean = false;
  isAllowedForAppeal: boolean = false;
  appealReject: boolean = false;
  appealApprove: boolean = false;
  appealHearingRemark: boolean = false;
  isAppealApproved: boolean = false;
  isAppealApprovedByAppllate: boolean = false;

  appealHearingStatus: boolean = false;
  rejectStatus: boolean = false;
  isappealHearingType: boolean = false;
  appealDateIs: boolean;
  appellateOfficer: boolean;
  nodelOfficer: boolean;
  selectedFile: File;
  dateColorFormat: Date;
  showOrderDocFile: string;
  form: FormGroup = new FormGroup({});
  installmentAppealModel: InstallmentAppealModel[] = [];
  page: Page<InstallmentExtendModel>;
  displayedColumns: string[] = [
    "id",
    "installmentType",
    // "transactionId",
    "oldInstallmentEndDate",
    "extendDays",
    // "appealType",
    // "applicantStatus",

    // "transactionDate",
    // "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  showtable: number = 5000001;
  source: string;
  orderDocumentFile: string | ArrayBuffer;
  orderDocumentFileFOrView: string | ArrayBuffer;
  orderDocument: string;
  orderFile: string;

  constructor(
    private route: ActivatedRoute,
    private paymentSettlementService: PaymentSettlementService,
    private modalCtrl: ModalController,
    private auditTrailService: AuditTrailService,
    private router: Router,
    public actionSheetController: ActionSheetController,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private _snackBar: MatSnackBar,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.loadInstallment();

    this.form = new FormGroup({
      installmentFormList: new FormArray([]),
    });
  }

  // isDateLessThanToday(date: string): boolean {
  //   const inputDate = date;
  //   const currentDate = new Date();
  //   const formattedDate = this.datePipe.transform(
  //     new Date(currentDate),
  //     "dd/MM/yyyy HH:mm:ss"
  //   );

  //   return inputDate < formattedDate;
  // }
  isDateLessThanToday(date: string): boolean {
    // console.log(date, new Date(), new Date(date))
    // console.log(this.convertAndCompare(date));
    return new Date(date) <= new Date();
  }
  // formatOldInstallmentEndDate(date: string): string {
  //   // Use DatePipe to format the date
  //   return this.datePipe.transform(new Date(date), "dd/MM/yyyy HH:mm:ss");
  // }

  loadInstallment() {
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.appealType = params["appealType"];
      this.paymentSettlementService
        .fetchInstallmentType(this.applicationNo, this.appealType)
        .subscribe(async (page: any) => {
          console.log(" data ", page);
          // if (data.status === "SUCCESS") {
          this.page = page;
          this.dateColorFormat = page.content.oldInstallmentEndDate;
          // } else {
          //   this.paymentSettlementService.errorToast(data.errorMessage);
          // }
          let installmentFormList: FormArray = this.form.get(
            "installmentFormList"
          ) as FormArray;

          for (let k = 0; k < page.content.length; k++) {
            let installmentObj = page.content[k];

            let frmGrp = new FormGroup({
              key: new FormControl(installmentObj.key),
              installmentType: new FormControl(installmentObj.installmentType),
              oldInstallmentEndDate: new FormControl(
                installmentObj.oldInstallmentEndDate
              ),
              oldInstallmentEndDateNew: new FormControl(
                installmentObj.oldInstallmentEndDateNew
              ),
              extendDaysValue: new FormControl(installmentObj.extendDaysValue),
              paymentStatus: new FormControl(installmentObj.paymentStatus),
              instPaymentInterestRate: new FormControl(
                installmentObj.instPaymentInterestRate
              ),
              newInstPaymentInterestRate: new FormControl(
                installmentObj.newInstPaymentInterestRate
              ),
            });
            this.isDateLessThanToday(installmentObj.oldInstallmentEndDate);

            installmentFormList.push(frmGrp);
            // console.log("frmGrp", frmGrp.value);
          }

          // if (page.content[0] !== null) {
          //   this.dataSource = new MatTableDataSource(page.content);
          // } else {
          //   this.dataSource = new MatTableDataSource<InstallmentTypeModel>([]);
          // }
        });
    });
  }
  loadData() {
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.appealType = params["appealType"];
      localStorage.setItem("appeal-view-appealType", this.appealType);
      // this.source = params["source"];
      // console.log("this.appealType", this.appealType);
      this.isLoading = true;
      this.paymentSettlementService
        .fetchAppealDetailView(this.applicationNo, this.appealType)
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            // console.log("aala ka ethe", data);
            if (data.status === "SUCCESS") {
              this.data = data;

              this.appealReject = data.appealReject != null ? true : false;
              this.appealApprove = data.appealApprove != null ? true : false;
              this.appealHearingRemark =
                data.appealHearingRemark != null ? true : false;
              this.isAllowedForAppeal = data.appealDate != null ? true : false;
              this.isAppealApproved =
                data.appealHearingStatus == "APPROVED" ? true : false;
              this.appealHearingStatus =
                data.appealHearingStatus == "Allowed_For_Hearing"
                  ? true
                  : false;
              this.isAppealApprovedByAppllate =
                data.appealHearingStatus == "APPROVED_BY_APPLLATE_OFFICER"
                  ? true
                  : false;
              this.rejectStatus =
                data.appealHearingStatus == "REJECTED" ? true : false;
              this.isappealHearingType =
                data.appealType == "PAYMENT_DEFAULTER" ? true : false;
              this.appealDateIs = data.appealDateIs;
              this.showOrderDocFile = data.orderDocumentFile;
              this.appellateOfficer = data.appellateOfficer;
              this.nodelOfficer = data.nodelOfficer;

              // console.log("this.data", this.data);
            } else {
              this.paymentSettlementService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            this.paymentSettlementService.errorToast(
              error?.error?.errorMessage || error?.error?.message
            );
          }
        );
    });
  }

  showappealdocfile() {
    appealdocfile: String;
    this.isLoading = true;
    // console.log("this.applicationKey", this.applicationNo);
    this.paymentSettlementService
      .fetchAppealDocFile("appealdocfile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Additional Appeal Document",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            //  this.preLotteryApplicationService.showErrorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          //  this.preLotteryApplicationService.showErrorToast("Unable to fetch As File");
        }
      );
  }

  openPreviewOtherDocumentFile() {
    this.PreviewOtherDocumentfile(this.orderDocumentFileFOrView);
  }

  async PreviewOtherDocumentfile(base64) {
    appealdocfile: String;
    this.isLoading = true;
    this.isLoading = false;
    const base64Data = base64.split(",")[1];
    const modal = await this.modalCtrl.create({
      component: ViewPdfComponent,
      componentProps: {
        base64: base64Data,
        documentName: "Order Letter",
        fileName:
          "ACKNOWLEDGEMENT_" +
          this.applicationNo +
          "_" +
          new Date().getTime() +
          ".pdf",
      },
    });
    modal.present();
  }

  showOrderDocumentfile() {
    appealdocfile: String;
    this.isLoading = true;
    // console.log("this.applicationNo", this.applicationNo);
    this.paymentSettlementService
      .fetchOrderfile("orderfile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Order Letter",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            //  this.preLotteryApplicationService.showErrorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          //  this.preLotteryApplicationService.showErrorToast("Unable to fetch As File");
        }
      );
  }
  showappealfile() {
    orderdocfile: String;
    this.isLoading = true;
    // console.log("this.applicationNo", this.applicationNo);
    this.paymentSettlementService
      .fetchAppealfile("appealfile", this.applicationNo)
      .subscribe(
        async ({ status, data, errorMessage }) => {
          this.isLoading = false;
          if (status === "SUCCESS") {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Appeal Letter",
                fileName:
                  "ACKNOWLEDGEMENT_" +
                  this.applicationNo +
                  "_" +
                  new Date().getTime() +
                  ".pdf",
              },
            });
            modal.present();
          } else {
            //  this.preLotteryApplicationService.showErrorToast(errorMessage);
          }
        },
        (error) => {
          this.isLoading = false;
          //  this.preLotteryApplicationService.showErrorToast("Unable to fetch As File");
        }
      );
  }
  validateOrderDocFile() {
    return typeof this.orderDocumentFile === "string" ? true : false;
  }
  async reject() {
    if (!this.validateOrderDocFile()) {
      return this._snackBar.open("Order Document File Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 10 * 1000,
      });
    }
    const modal = await this.modalCtrl.create({
      component: AppealRejectComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "reject") {
      console.log("DATA", data);
      // new API to update to update reject reasone
      this.paymentSettlementService
        .rejectedAppeal({
          applicationNo: this.applicationNo.toString(),
          appealType: this.appealType,
          remark: data,
          orderFile: this.orderFile,
          orderDocumentFile: this.orderDocumentFile,
          reject: "REJECTED",
          approve: "",
        })
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
          this.loadData();
          this._snackBar.open("Appeal Request REJECTED", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "danger-toast",
            duration: 3 * 1000,
          });
          this.router.navigate(["/secure", "appeal-hearing"]);
        });
    }
  }
  async approvedDocument() {
    if (!this.validateOrderDocFile()) {
      return this._snackBar.open("Order Document File Is Required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 10 * 1000,
      });
    }
    const modal = await this.modalCtrl.create({
      component: AppealApproveDocComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === "approve") {
      console.log("DATA", data);
      // new API to update to update reject reasone
      this.paymentSettlementService
        .saveApprovedDocument({
          applicationNo: this.applicationNo.toString(),
          appealType: this.appealType,
          remark: data,
          orderFile: this.orderFile,
          orderDocumentFile: this.orderDocumentFile,
          reject: "",
          approve: "APPROVED",
        })
        .subscribe((data) => {
          console.log(data, "fromStatus files API");
          this.loadData();
          this._snackBar.open("Appeal Request APPROVED", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
          this.router.navigate(["/secure", "appeal-hearing"]);
        });

      // this.onSubmit('REJECTED', data);
    }
    // this.paymentSettlementService
    //   .saveApprovedDocument(this.applicationNo.toString(), this.appealType)
    //   .subscribe((data) => {
    //     this.isLoading = false;
    //     this.loadData();
    //     this._snackBar.open("Appeal Approved Successfully", "Close", {
    //       horizontalPosition: "right",
    //       verticalPosition: "top",
    //       panelClass: "success-toast",
    //       duration: 3 * 1000,
    //     });
    //   });
  }
  async appealHearing(status: any) {
    console.log("this.data.additionalDocumentFile", this.data);
    if (!this.data.additionalDocumentFile) {
      return this._snackBar.open(
        "Additional Document file is required",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
    } else if (!this.data.appealLetterFile) {
      return this._snackBar.open("Appeal Letter file is required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
    }
    const modal = await this.modalCtrl.create({
      component: AppealCallHearingComponent,
      componentProps: {
        pan: this.applicationNo,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();

    if (role === "Allowed_For_Hearing") {
      console.log(
        "data.appealDatedata.appealDate",
        moment(data.appealDate).format("DD-MM-YYYY HH:mm:ss")
      );
      this.isLoading = true;
      this.paymentSettlementService
        .saveAppealHearing({
          status,
          applicationNo: this.applicationNo.toString(),
          appealDate: moment(data.appealDate).format("DD-MM-YYYY HH:mm:ss"),
          remark: data.remark,

          appealType: this.appealType,
        })
        .subscribe((data) => {
          this.isLoading = false;

          this.loadData();
          this.router.navigate(["/secure", "appeal-hearing"]);
          this._snackBar.open("Appeal Hearing Successfully", "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "success-toast",
            duration: 3 * 1000,
          });
        });
    }
  }

  // async approvedPayment() {
  //   this.paymentSettlementService
  //     .saveApprovedPayment({
  //       applicationNo: this.applicationNo.toString(),
  //       appealType: this.appealType,
  //       appealResponsibilities: this.form.value.installmentFormList.map(
  //         (ur) => ({
  //           // key: ur.key,
  //           extendDaysValue: ur.extendDaysValue,
  //           oldInstallmentEndDate: ur.oldInstallmentEndDate,
  //           installmentType: ur.installmentType,
  //         })
  //       ),
  //     })
  //     .subscribe((data) => {
  //       this.isLoading = false;
  //       this.loadData();
  //       console.log(data, "fromStatus files API");
  //       this._snackBar.open("Appeal Approved Successfully", "Close", {
  //         horizontalPosition: "right",
  //         verticalPosition: "top",
  //         panelClass: "success-toast",
  //         duration: 3 * 1000,
  //       });
  //     });
  // }
  //
  newExtendedDate(oldDate, extendDays) {
    if (oldDate && extendDays) {
      return moment(oldDate, "DD/MM/YYYY HH:mm:ss")
        .add(extendDays, "days")
        .format("DD/MM/YYYY HH:mm:ss");
    } else return null;
  }
  newInstPaymentInterestRateCal(oldInsRate, newInsRate) {
    // console.log('newInstPaymentInterestRateCal call', oldInsRate, newInsRate);
    // console.log(typeof (oldInsRate), typeof (newInsRate));
    if (+newInsRate) {
      console.log("Inner Method Call");
      return +oldInsRate + Number(newInsRate);
    } else return null;
  }
  onOrderFileSelect(event) {
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        console.log("this.selectedFile", this.selectedFile);
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.orderDocumentFile = reader.result;
          this.orderDocumentFileFOrView = this.orderDocumentFile;
          const fileNameParts = this.selectedFile.name.split(".");
          this.orderFile = this.selectedFile.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.orderDocument = fileNameWithoutExtension;
          // this.previewDocumentfile(this.orderDocumentFile);
        };

        console.log("reader 1", reader.result);
      } else {
        this.selectedFile = null;
        this.orderDocumentFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.orderDocumentFile = null;
      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }
  async approvedPayment() {
    const currentDate = new Date();
    const hasError = this.form.value.installmentFormList.some((ur) => {
      const extendDaysValue = ur.extendDaysValue;
      const oldInstallmentEndDate = ur.oldInstallmentEndDate;
      const paymentStatus = ur.paymentStatus;

      let contractMoment = moment(oldInstallmentEndDate, "DD/MM/YYYY HH:mm:ss");
      let newDate = moment(contractMoment).add(extendDaysValue, "days");

      if (
        newDate.toDate() < currentDate &&
        paymentStatus !== "PAYMENT_RECEIVED"
      ) {
        return true;
      }
      return false;
    });
    // const paymentError = this.form.value.installmentFormList.some((ur) => {
    //   const paymentStatus = ur.paymentStatus;
    //   console.log(
    //     "this.form.value.installmentFormList",
    //     this.form.value.installmentFormList
    //   );
    //   if (paymentStatus === "PAYMENT_RECEIVED") {
    //     return false;
    //   }
    //   return true;
    // });
    const paymentError = this.form.value.installmentFormList.some(
      (ur) =>
        ur.paymentStatus === "PAYMENT_RECEIVED" ||
        (ur.paymentStatus === "PAYMENT_NOT_RECEIVED" &&
          ur.extendDaysValue != null) ||
        (ur.paymentStatus === "PARTIAL_PAYMENT_RECEIVED" &&
          ur.extendDaysValue != null) ||
        (ur.paymentStatus === null && ur.extendDaysValue != null)
    );

    console.log("paymentErrorpaymentError", paymentError);

    if (!paymentError) {
      if (hasError) {
        this._snackBar.open("Date less than current date", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
        console.error("Date less than current date");
      }
      // this._snackBar.open("PAYMENT_RECEIVED", "Close", {
      //   horizontalPosition: "right",
      //   verticalPosition: "top",
      //   panelClass: "error-toast",
      //   duration: 3 * 1000,
      // });
    } else if (hasError) {
      this._snackBar.open("Date less than current date", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
      console.error("Date less than current date");
    } else {
      // if (!this.validateOrderDocFile()) {
      //   return this._snackBar.open("Order Document File Is Required", "Close", {
      //     horizontalPosition: "right",
      //     verticalPosition: "top",
      //     panelClass: "error-toast",
      //     duration: 10 * 1000,
      //   });
      // }
      const modal = await this.modalCtrl.create({
        component: AppealApproveDocComponent,
        componentProps: {
          pan: this.applicationNo,
        },
      });
      modal.present();

      const { data, role } = await modal.onWillDismiss();
      if (role === "approve") {
        this.paymentSettlementService
          .saveApprovedPayment({
            remark: data,
            // orderFile: this.orderFile,
            // orderDocumentFile: this.orderDocumentFile,
            reject: "",
            approve: "APPROVED",
            applicationNo: this.applicationNo.toString(),
            appealType: this.appealType,
            appealResponsibilities: this.form.value.installmentFormList.map(
              (ur) => ({
                extendDaysValue: ur.extendDaysValue,
                oldInstallmentEndDate: ur.oldInstallmentEndDate,
                installmentType: ur.installmentType,
                newInstPaymentInterestRate: ur.newInstPaymentInterestRate,
              })
            ),
          })
          .subscribe((data) => {
            this.isLoading = false;
            this.loadData();
            console.log(data, "fromStatus files API");
            this._snackBar.open("Appeal Approved Successfully", "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "success-toast",
              duration: 3 * 1000,
            });
            this.router.navigate(["/secure", "appeal-hearing"]);
          });
      }
    }
  }

  get installmentList() {
    return this.form.get("installmentFormList")["controls"];
  }
}
